import Header from "../../../sections/Header/Header";
import React from "react";
import TitleBgCoursesQM from "../../../sections/TitleBgCourses/TitlepicCourses/TitleBgCoursesQM/TitleBgCoursesQM";
import CoursesPicCont from "../../../sections/TitleBgCourses/CoursesPicCont/CoursesPicCont";
import Trial from "../../../sections/Bookfreetrial/Trial";
import Footer from "../../../sections/Footer/Footer";

const CoursesQM =()=>{
    return(
        <div>
            <Header/>
            <TitleBgCoursesQM/>
            <CoursesPicCont/>
            <Trial/>
            <Footer/>
        </div>
    )
}
export default CoursesQM;